import { type Component, createApp } from 'vue'
import { createPinia } from 'pinia'
import { ConfirmationService, DialogService, FocusTrap, ToastService } from 'primevue'
import Tooltip from 'primevue/tooltip'
import { PrimeVue } from '@primevue/core'
import { PrenoThemePreset } from '@/theme.ts'

export const registerServices = (rootComponent: Component, themePreset = PrenoThemePreset) => {
    const app = createApp(rootComponent)

    app.use(createPinia())
    app.use(ToastService)
    app.use(DialogService)
    app.use(ConfirmationService)
    app.directive('tooltip', Tooltip)
    app.directive('focustrap', FocusTrap)

    app.use(PrimeVue, {
        theme: {
            preset: themePreset,
            options: {
                prefix: 'p',
                darkModeSelector: 'none',
            },
        },
        ripple: true,
        nonce: window.PnBaseData.security.nonce,
    })

    return app
}
